import dayjs from 'dayjs';
import { CoinType, CoinTypeChain, CoinTypeLabel } from '../enum';

export const getCoinLabel: (val: string) => string = (val) => {
  switch (val) {
    case CoinType.BTC:
      return CoinTypeLabel.BTC;
    case CoinType.ETH:
      return CoinTypeLabel.ETH;
    default:
      return '';
  }
};

export const getCoinChain: (val: string) => string = (val) => {
  switch (val) {
    case CoinType.BTC:
      return CoinTypeChain.BTC;
    case CoinType.ETH:
      return CoinTypeChain.ETH;
    default:
      return '';
  }
};

export const formatTime = (time:number = 0) => {
  const n = dayjs(time * 1000).format('YYYY-MM-DD');
  return n;
};

export const isWin = () => /windows|win32/i.test(navigator.userAgent);
